import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const CommentSection = ({ comments: initialComments, articleId }) => {
  const [comments, setComments] = useState(initialComments);
  const [newComment, setNewComment] = useState('');
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyText, setReplyText] = useState('');

  const handleAddComment = () => {
    if (!newComment?.trim()) return;

    const comment = {
      id: Date.now(),
      author: {
        name: 'You',
        avatar: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
        avatarAlt: 'Your profile picture'
      },
      content: newComment,
      timestamp: 'Just now',
      likes: 0,
      replies: []
    };

    setComments([comment, ...comments]);
    setNewComment('');
  };

  const handleAddReply = (commentId) => {
    if (!replyText?.trim()) return;

    const reply = {
      id: Date.now(),
      author: {
        name: 'You',
        avatar: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
        avatarAlt: 'Your profile picture'
      },
      content: replyText,
      timestamp: 'Just now',
      likes: 0
    };

    setComments(comments?.map((comment) =>
    comment?.id === commentId ?
    { ...comment, replies: [...comment?.replies, reply] } :
    comment
    ));

    setReplyText('');
    setReplyingTo(null);
  };

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 border border-border">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="MessageSquare" size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-xl md:text-2xl font-semibold text-foreground">
          Comments ({comments?.length})
        </h3>
      </div>
      <div className="mb-6">
        <Input
          type="text"
          placeholder="Share your thoughts on this article..."
          value={newComment}
          onChange={(e) => setNewComment(e?.target?.value)}
          className="mb-3" />

        <Button
          variant="default"
          onClick={handleAddComment}
          disabled={!newComment?.trim()}
          iconName="Send"
          iconPosition="right">

          Post Comment
        </Button>
      </div>
      <div className="space-y-6">
        {comments?.map((comment, index) =>
        <motion.div
          key={comment?.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1, duration: 0.4 }}
          className="space-y-4">

            <div className="flex gap-4">
              <Image
              src={comment?.author?.avatar}
              alt={comment?.author?.avatarAlt}
              className="w-10 h-10 rounded-full object-cover flex-shrink-0" />


              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <span className="font-semibold text-foreground text-sm md:text-base">
                    {comment?.author?.name}
                  </span>
                  <span className="text-xs text-muted-foreground">
                    {comment?.timestamp}
                  </span>
                </div>

                <p className="text-sm md:text-base text-foreground mb-3">
                  {comment?.content}
                </p>

                <div className="flex items-center gap-4">
                  <button className="flex items-center gap-1.5 text-xs md:text-sm text-muted-foreground hover:text-primary transition-colors">
                    <Icon name="ThumbsUp" size={14} color="currentColor" />
                    <span>{comment?.likes}</span>
                  </button>
                  <button
                  onClick={() => setReplyingTo(comment?.id)}
                  className="text-xs md:text-sm text-muted-foreground hover:text-primary transition-colors">

                    Reply
                  </button>
                </div>

                {replyingTo === comment?.id &&
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                className="mt-4">

                    <Input
                  type="text"
                  placeholder="Write a reply..."
                  value={replyText}
                  onChange={(e) => setReplyText(e?.target?.value)}
                  className="mb-2" />

                    <div className="flex gap-2">
                      <Button
                    variant="default"
                    size="sm"
                    onClick={() => handleAddReply(comment?.id)}
                    disabled={!replyText?.trim()}>

                        Reply
                      </Button>
                      <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => {
                      setReplyingTo(null);
                      setReplyText('');
                    }}>

                        Cancel
                      </Button>
                    </div>
                  </motion.div>
              }

                {comment?.replies && comment?.replies?.length > 0 &&
              <div className="mt-4 pl-6 border-l-2 border-border space-y-4">
                    {comment?.replies?.map((reply) =>
                <div key={reply?.id} className="flex gap-3">
                        <Image
                    src={reply?.author?.avatar}
                    alt={reply?.author?.avatarAlt}
                    className="w-8 h-8 rounded-full object-cover flex-shrink-0" />

                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-1">
                            <span className="font-semibold text-foreground text-sm">
                              {reply?.author?.name}
                            </span>
                            <span className="text-xs text-muted-foreground">
                              {reply?.timestamp}
                            </span>
                          </div>
                          <p className="text-sm text-foreground mb-2">
                            {reply?.content}
                          </p>
                          <button className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-primary transition-colors">
                            <Icon name="ThumbsUp" size={12} color="currentColor" />
                            <span>{reply?.likes}</span>
                          </button>
                        </div>
                      </div>
                )}
                  </div>
              }
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );


};

export default CommentSection;